// extracted by mini-css-extract-plugin
module.exports = {"md":"content_md_3pIxw","ios":"content_ios_2sn6O","content":"content_content_3BLmb"};